<template>
    <v-card
        style="min-height: 100%; max-height: 779px"
        :disabled="loading"
        class="d-flex flex-column justify-space-between"
    >
        <v-card-text
            style="max-height: inherit; overflow-y: hidden; height: 100%"
            class="pb-0 flex-grow-1 flex-shrink-0 d-flex flex-column"
        >
            <v-tabs v-model="tab" fixed-tabs class="flex-shrink-1 flex-grow-0">
                <v-tab>
                    Outputs
                    <TabCountBadge :record="record" :count="outputCount" />
                </v-tab>
                <v-tab>
                    Report
                    <TabCountBadge :record="record" :count="reportCount" />
                </v-tab>
                <v-tab>
                    Files
                    <TabCountBadge :record="record" :count="fileCount" />
                </v-tab>
            </v-tabs>
            <p v-if="isEmpty" class="pt-6 text-body-1 text-typography1">
                No outputs available. Please enter inputs then press the
                '<b>Calculate</b>' button.
            </p>
            <v-window
                v-else
                v-model="tab"
                class="pt-6 text-body-1 text-typography1 flex-grow-1"
                style="height: 100%"
            >
                <v-window-item style="width: 100%" :class="[noButtonsPadding]">
                    <Output
                        :record="record"
                        :calc="calc"
                        :maxHeight="maxHeightNoButtons"
                    />
                </v-window-item>
                <v-window-item style="width: 100%">
                    <Report :record="record" :maxHeight="maxHeightButtons" />
                </v-window-item>
                <v-window-item style="width: 100%" :class="[noButtonsPadding]">
                    <Files :record="record" :maxHeight="maxHeightNoButtons" />
                </v-window-item>
            </v-window>
        </v-card-text>
        <v-card-actions class="py-0 pr-0" style="height: 83px">
            <ReportButtons class="pr-4" v-if="tab === 1" :record="record" />
        </v-card-actions>
    </v-card>
</template>
<script setup>
import { ref, computed } from 'vue'
import Output from './calc-outputs/Output.vue'
import Report from './calc-outputs/Report.vue'
import ReportButtons from './calc-outputs/ReportButtons.vue'
import Files from './calc-outputs/Files.vue'
import TabCountBadge from './calc-outputs/TabCountBadge.vue'

const props = defineProps([
    'record',
    'calc',
    'loading',
    'maxHeightNoButtons',
    'maxHeightButtons',
    'noButtonsPadding',
])

const tab = ref(0)

const isEmpty = computed(() => Object.keys(props.record).length === 0)

const outputCount = computed(() => {
    if (!props.record.output) return 0
    let count = 0
    if (props.record.output.result) {
        if (!props.record.calc.hasFileOutputs) count = 1
    } else if (props.record.output.arupComputeResultItems) {
        count = props.record.output.arupComputeResultItems.length
    }
    return count
})

const reportCount = computed(() => {
    let count = 0
    if (props.record.output && props.record.output.arupComputeReport_HTML)
        count = 1
    return count
})

const fileCount = computed(() => {
    if (!props.record.output) return 0
    let count = 0
    if (props.record.output.result) {
        if (props.record.calc.hasFileOutputs) count = 1
    } else if (props.record.output.arupComputeResultFileItems) {
        count = props.record.output.arupComputeResultFileItems.length
    }
    return count
})
</script>
